<template>
  <div class="header-panel">
    <div class="nav-section">
      <div class="logo-pic" @click="goIndexPage"></div>
      <div class="nav-group">
        <div class="nav-item" v-for="(navItem, index) in navArr" :key="navItem.id" @click="handleNav(navItem, index)">
          <div :class="[activeIndex === index ? 'active-name' : 'nav-name']">{{navItem.text}}</div>
          <div v-if="activeIndex === index" class="active-line"></div>
        </div>
        
      </div>
    </div>
  </div>  
</template>

<script>

export default {
  name: 'headerView',
  props: {
    activeIndex: {
      type: Number
    }
  },
  components: {
  },
  data () {
    return {
      // activeIndex: 0,
      navArr: [{
        id: 1,
        text: 'Home',
        linkUrl: '/'
      }, {
        id: 2,
        text: 'Core Business',
        linkUrl: '/coreBusiness'
      }, {
        id: 3,
        text: 'Service&Projects',
        linkUrl: '/services'
      }, {
        id: 4,
        text: 'Why us',
        linkUrl: '/whyUs'
      }, {
        id: 5,
        text: 'Capabilities',
        linkUrl: '/capabilities'
      }, {
        id: 6,
        text: 'HSE',
        linkUrl: '/hse'
      }, {
        id: 7,
        text: 'Contact us',
        linkUrl: '/contactUs'
      }],
    }
  },
  methods: {
    goIndexPage() {
      this.$router.replace({ path: "/" })
    },

    handleNav (navItem, index) {
      // console.log('======navItem', navItem, navItem.linkUrl)
      this.$router.replace({ path: navItem.linkUrl })
    }
  },
  created () {

  }
}
</script>
<style scoped lang="scss">
.header-panel {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid rgba(255,255,255, 0.1);
  position: relative;
  z-index: 99;
  margin-top: -1px;
}

.nav-section {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  display: flex;
}

.logo-pic {
  width: 150px;
  height: 80px;
  background: url('../assets/spsc/logo.png') no-repeat;
  background-size: contain;
  cursor: pointer;
}

.nav-group {
  width: 890px;
  display: flex;
  justify-content: space-between;
  margin-left: 160px;
}

.nav-item {
  height: 80px;
  line-height: 80px;
  position: relative;
}

.active-name {
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
  cursor: pointer;
}

.nav-name {
  font-size: 18px;
  color: #FFFFFF;
  opacity: 0.6;
  cursor: pointer;
}

.active-line {
  position: absolute;
  bottom: -1px;
  width: 100%;
  height: 3px;
  background: #0281C1;
}
</style>
